module.exports = __webpack_public_path__ + "img/31.2f8e4f86.png";